import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AbacusNd05Map } from 'src/app/classes/map/maps/abacus.nd.0.5.map';
import { AbacusNd1Map } from 'src/app/classes/map/maps/abacus.nd.1.map';
import { RoadMap } from 'src/app/classes/map/maps/road.map';
import { Abacus } from 'src/app/classes/messages/density.aware.spray.and.wait/abacus';
import { DensityAwareSprayAndWait } from 'src/app/classes/messages/density.aware.spray.and.wait/density.aware.spray.and.wait';
import { Message } from 'src/app/classes/messages/message';
import { MessagingSystem } from 'src/app/classes/messages/messaging.system';
import { Node } from 'src/app/classes/node';
import { Results } from 'src/app/classes/results';
import { Settings } from 'src/app/classes/settings/settings';
import { SimulationState } from 'src/app/enums/simulation.state.enum';

@Component({
  selector: 'app-simulator',
  templateUrl: './simulator.component.html',
  styleUrls: ['./simulator.component.scss']
})
export class SimulatorComponent implements OnInit {

  public simStartTime: number = Date.now();
  public simEndTime: number = Date.now() + (this.settings.simTime * 10);

  //@todo pause

  public nodeMsgLoop: any;
  public paused: boolean = false;

  public selectedNodeToShowDetails:Node|null = null;

  public nodes: Array<Node> = [];

  public abaciTraining: boolean = false;
  public abaciToTrainNoCopiesIndex: number = 0;
  public abaciToTrainAvgNodeDegreeIndex: number = 0;

  @ViewChild('resultsModal', { read: TemplateRef }) resultsModal:TemplateRef<any> | undefined;

  public results: Results|undefined;

  private map: RoadMap|undefined;

  // Simulation State for Event Log
  public numMsgsInCirculation = 0;
  public simState = SimulationState.ABACI_TRAINING;
  public curNodeDegree = this.settings.ABACI_TO_CREATE.avgNodeDegree[this.abaciToTrainAvgNodeDegreeIndex];

  constructor(public router: Router,
              private route: ActivatedRoute, 
              public settings: Settings,
              private modalService: NgbModal) {}

  ngOnInit() {
    // Draw map
    this.map = new AbacusNd05Map();

    this.settings.algorithm =  parseInt(this.route.snapshot.paramMap.get('algorithm') ?? this.settings.algorithm.toString()) ?? this.settings.algorithm;
    this.settings.numNodes = parseInt(this.route.snapshot.paramMap.get('noNodes') ?? this.settings.numNodes.toString()) ?? this.settings.numNodes;
    this.settings.simSpeed = parseInt(this.route.snapshot.paramMap.get('simSpeed') ?? this.settings.simSpeed.toString()) ?? this.settings.simSpeed;
    this.settings.simTime = parseInt(this.route.snapshot.paramMap.get('simTime') ?? this.settings.simTime.toString()) ?? this.settings.simTime;
    this.settings.nodeRadius = parseInt(this.route.snapshot.paramMap.get('nodeRadius') ?? this.settings.nodeRadius.toString()) ?? this.settings.nodeRadius;
    this.settings.msgFreq = parseInt(this.route.snapshot.paramMap.get('msgFreq') ?? this.settings.msgFreq.toString()) ?? this.settings.msgFreq;
    this.settings.numMsgCopies = parseInt(this.route.snapshot.paramMap.get('numMsgCopies') ?? this.settings.numMsgCopies.toString()) ?? this.settings.numMsgCopies;

    this.simEndTime = Date.now() + (this.settings.simTime * 10);
    
    this.generateNodes(this.settings.numNodes);

    this.selectNodeToShowDetails(this.nodes[0]);

    if(this.settings.algorithm == MessagingSystem.DensityAwareSprayAndWait) {
      this.trainingLoop();
    } else {
      this.mainSimLoop();
    }
   
  }


  trainingLoop() {
    this.abaciTraining = true;

    // Train all abaci loop
    let sentAllMsgs = false;
    let receivedAllMsgs = false;

    let curNode = this.nodes[0];

    let trainInterval = setInterval(() => {

      this.updateEventLog();

      // Once all training messages have been sent and received.
      if(sentAllMsgs && receivedAllMsgs) {
        clearInterval(trainInterval);
        this.endTraining();
        this.mainSimLoop();
      }

      // If there are still messages to send
      if(!sentAllMsgs) { 

        // copiesIndex Loop
        if(this.abaciToTrainNoCopiesIndex <= this.settings.ABACI_TO_CREATE.numCopies.length - 1) {

          // Send training messages for this abacus.
          for (let i = 0; i < this.settings.TRAIN_MESSAGES_PER_ABACI; i++) {
            this.sendRandomMessage(curNode);
          }

          let iNodeIndex = this.nodes.findIndex((node: Node) => node == curNode);

          if(iNodeIndex >= this.nodes.length - 1) {
            iNodeIndex = 0;
            curNode = this.nodes[0];

            // Incremeent noCopies index.
            this.abaciToTrainNoCopiesIndex++;
          }

          // Get next node
          iNodeIndex++;
          curNode = this.nodes[iNodeIndex];

        } else {

          // If there are still messages to receive, don't update the node degree, wait for the messages
          // so if there are no msgs left, then move on.
          if(this.getNumMsgsStillToArrive() <= 0) {

            this.nodes.forEach((node: Node) => {
              node.messagingSystem.nodeDegrees = [];
            });

            this.abaciToTrainNoCopiesIndex = 0;
            this.abaciToTrainAvgNodeDegreeIndex++;
            this.curNodeDegree = this.settings.ABACI_TO_CREATE.avgNodeDegree[this.abaciToTrainAvgNodeDegreeIndex]

            // Check if all messages have been sent.
            if(this.abaciToTrainAvgNodeDegreeIndex >= this.settings.ABACI_TO_CREATE.avgNodeDegree.length) {
              sentAllMsgs = true;
            } 

            this.updateMap(
              this.settings.NODE_DEGREE_TO_MAP[
                this.settings.ABACI_TO_CREATE.avgNodeDegree[
                  this.abaciToTrainAvgNodeDegreeIndex
                ]
              ]
            );
          }
        }
      }

      // Spray Messages loop
      this.sprayMessagesBetweenNodes();

      // If no more messages to receive, end it.
      if(this.getNumMsgsStillToArrive() <= 0) {
        receivedAllMsgs = true;
      }

    }, this.getSimLoopTime());
  }


  endTraining() {
    // Add data to abaci
    this.nodes.forEach((node : Node) => {
      node.messagingSystem.messages.forEach((message: Message) => {
        message.abacus?.addData(message.timeTakenToArrive);
      });

      // Calculate values for abaci
      node.messagingSystem.abaci.forEach((abacus: Abacus) => {
        abacus.calculateValues();
      });
    });

    // Remove training from all nodes
    this.nodes.forEach((node: Node) => {
      node.messagingSystem.receivedMessages = [];
      node.messagingSystem.uniqueSentMessages = [];
      node.messagingSystem.droppedMessages = [];

      node.messagingSystem.totalSentMsgCount = 0;
    });

    this.settings.MAX_NODE_CAPACITY = 100;
  }



  mainSimLoop() {
    this.simState = SimulationState.SIMULATION;
    this.updateMap(AbacusNd1Map);
    this.simStartTime = Date.now();
    this.simEndTime = Date.now() + (this.settings.simTime * 10);
    
    // Actual simulation
    this.nodeMsgLoop = setInterval(() => {
      if(this.paused) return;

      this.updateEventLog();

      if(Date.now() >= this.simEndTime) {
        this.stopSimulation();
      }

      // Message creation after abaciTraining has finished.
      let shouldCreateMessage = Math.floor(Math.random() * (this.settings.MAX_MESSAGE_FREQUENCY + 1 - this.settings.msgFreq)) <= 1;

      if(shouldCreateMessage) {
        let msgID = Math.floor(Math.random() * 650000);
        let srcNode = this.getRandomNode();
        let destNode = this.getRandomNode(srcNode);
        let msgSize = Math.floor(Math.random() * this.settings.MAX_MESSAGE_SIZE);
        let abacus = undefined;

        if(typeof srcNode.messagingSystem['getDesiredAbacus'] === 'function') { 
          abacus = srcNode.messagingSystem.getDesiredAbacus(srcNode.messagingSystem.avgNodeDegree, this.settings.DESIRED_AVG_DELAY)
        }

        let msgToBeSent = 
          new Message(msgID, 
                      srcNode, 
                      destNode, 
                      msgSize, 
                      abacus
        );

        srcNode.messagingSystem.createNewMessage(msgToBeSent);
      }

      this.sprayMessagesBetweenNodes();
  
    }, this.getSimLoopTime());
  }

  stopSimulation() {
    clearInterval(this.nodeMsgLoop);
    this.pause();

    this.simState = SimulationState.ENDED;

    console.log(this.nodes);

    this.nodes.forEach((node: Node) => {
      // Finalise routes taken
      node.messagingSystem.receivedMessages.forEach((receivedMsg: Message) => {
        receivedMsg.routeTaken = [...new Set(receivedMsg.routeTaken)];
        receivedMsg.routeTaken.push(node);
      });
    });

    console.log(this.getMsgsStillToArrive());

    // Calculate results by creating results object.
    this.results = new Results(this.nodes, this.simStartTime, this.simEndTime);

    // Show results modal
    this.modalService.open(this.resultsModal).result;

    this.updateEventLog();
  }


  generateNodes(noNodes: number) {
    for (let i = 0; i < noNodes; i++) {
      let randomStartingJunction = this.map!.getRandomJunction();
      
      this.nodes.push(new Node(randomStartingJunction, i, this.settings));
    }
  }

  getRandomNode(excludedNode: Node|undefined = undefined): Node {
    let randomNode = null;

    while(randomNode == null || randomNode == excludedNode) {
      randomNode = this.nodes[Math.floor(Math.random() * this.nodes.length - 1)];
    }

    return randomNode;
  }

  pause() {
    this.paused = true;

    // Pause nodes
    this.nodes.forEach((node: Node) => {
      node.pauseNode();
    });
  }


  unpause() {
    this.paused = false;

    // Pause nodes
    this.nodes.forEach((node: Node) => {
      node.unpauseNode();
    });
  }


  getSimLoopTime() {
    return (this.settings.MAX_SIMULATION_SPEED / this.settings.simSpeed) * 5;
  }

  sendRandomMessage(from: Node) {
    let msgID = Math.floor(Math.random() * 650000);
    let srcNode = from;
    let destNode = this.getRandomNode(from);
    let msgSize = Math.floor(Math.random() * this.settings.MAX_MESSAGE_SIZE);

    from.messagingSystem.createNewMessage(
      new Message(
        msgID, 
        srcNode,
        destNode,
        msgSize,
        from.messagingSystem.abaci.find((abacus: Abacus) => {
          return abacus.nodeDegree == this.settings.ABACI_TO_CREATE.avgNodeDegree[this.abaciToTrainAvgNodeDegreeIndex] && 
                 abacus.numCopies == this.settings.ABACI_TO_CREATE.numCopies[this.abaciToTrainNoCopiesIndex];
        })
      )
    );
  }

  sprayMessagesBetweenNodes() {
    // Send messages between nodes, and get node degree.
    this.nodes.forEach((outerNode: Node) => {
      let outerNodeDegree = 0;
      this.nodes.forEach((innerNode: Node) => {
        if(outerNode != innerNode && outerNode.isInRange(innerNode)) {
          outerNodeDegree++;
        
          innerNode.messagingSystem.sprayMessagesToDestination(outerNode);
          outerNode.messagingSystem.sprayMessagesToDestination(innerNode);
        }
      });
      // Update node degree array
      outerNode.messagingSystem.nodeDegrees.push(outerNodeDegree);

      // Calculate updated node degree
      outerNode.messagingSystem.avgNodeDegree = 
        outerNode.messagingSystem.nodeDegrees.reduce((a: number, b: number) => a + b, 0) / outerNode.messagingSystem.nodeDegrees.length;
    });
  }

  getNumMsgsStillToArrive(): number {
    let msgsYetToArrive: Array<Message> = [];
    this.nodes.forEach((node: Node) => {
      msgsYetToArrive = [...msgsYetToArrive, ...node.messagingSystem.messages]
    });
    return msgsYetToArrive.length;
  }

  getMsgsStillToArrive(): Array<Message> {
    let msgsYetToArrive: Array<Message> = [];
    this.nodes.forEach((node: Node) => {
      msgsYetToArrive = [...msgsYetToArrive, ...node.messagingSystem.messages]
    });
    return msgsYetToArrive;
  }

  updateMap(newMap: any) {
    this.map?.destroy();
    this.map = new newMap();
    this.nodes.forEach((node: Node) => {
      node.swapMap(this.map!.getRandomJunction());
    });

  }

  updateEventLog(): void {
    this.numMsgsInCirculation = this.getNumMsgsStillToArrive();
  }

  // Node details

  selectNodeToShowDetails(node: Node) {
    this.selectedNodeToShowDetails = node;
  }

  returnHome() {
    window.location.href = '/';

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/']);
  }

}